module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择采集来源"
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: index + 1,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company", $$v)
      },
      expression: "pdata.company"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择对应渠道"
    },
    model: {
      value: (_vm.pdata.channel_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "channel_id", $$v)
      },
      expression: "pdata.channel_id"
    }
  }, _vm._l((_vm.ChannelList), function(item, index) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ald_channel,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "导量来源"
    },
    model: {
      value: (_vm.pdata.data_source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "data_source", $$v)
      },
      expression: "pdata.data_source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "矩阵导量",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "广点通导量",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部渠道导量",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "clearable": "",
      "placeholder": "产品归属"
    },
    model: {
      value: (_vm.pdata.product_belongs),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "product_belongs", $$v)
      },
      expression: "pdata.product_belongs"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "内部矩阵",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部渠道",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通知下线",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已确认下线",
      "value": "2"
    }
  })], 1), _vm._v(" "), (_vm.dateVal[0] == _vm.dateVal[1]) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.updateCostHander
    }
  }, [_vm._v("更新成本")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "selfTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-class-name": _vm.tableRowClassName,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "default-sort": {
        prop: '_visit_uv_new',
        order: 'descending'
      }
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    staticClass: "expandd",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "日期",
            "align": "center",
            "width": "208px"
          }
        }), _vm._v(" "), (_vm.pdata.type != 3) ? _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "对应公司",
            "align": "center",
            "width": "100px"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ald_channel",
            "show-overflow-tooltip": "",
            "label": "对应渠道",
            "align": "center",
            "min-width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "type",
            "show-overflow-tooltip": "",
            "label": "采集来源",
            "align": "center",
            "min-width": "100px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "atv",
            "label": "单价",
            "align": "center",
            "min-width": "70px",
            "formatter": _vm.fixed2Formatter
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.atv))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "visit_uv_new",
            "label": "买量新增",
            "min-width": "100px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cost",
            "label": "买量成本",
            "align": "center",
            "min-width": "100px",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.cost - 0) - (b.cost - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_visit_uv_new",
            "label": "实际买量新增",
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "min-width": "130px",
            "prop": "_visit_uv",
            "label": "实际活跃用户",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._visit_uv - 0) - (b._visit_uv - 0)
            }
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "_cost",
            "label": "实际买量成本",
            "formatter": _vm.fixed2Formatter,
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a._cost - 0) - (b._cost - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cost_per",
            "label": "实际买量单价",
            "min-width": "130px",
            "align": "center",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.cost_per - 0) - (b.cost_per - 0)
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n\t\t\t                         ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "update_time",
            "label": "下线时间",
            "align": "center",
            "min-width": "140px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.update_time != null && (scope.row.status == 0 || scope.row.status == 2)) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v("--")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "",
            "label": "操作",
            "fixed": "right",
            "align": "center",
            "width": "290"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.groupid == 4 || _vm.groupid == 0 || _vm.groupid == 1) ? _c('el-button', {
                attrs: {
                  "size": "mini",
                  "type": "primary"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.editProduct(scope.row, s.$index)
                  }
                }
              }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "danger"
                },
                nativeOn: {
                  "click": function($event) {
                    return _vm.confirmOff(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("确认下线")]) : (scope.row.status == 1) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("正常")]) : (scope.row.status == 2) ? _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("已确认下线")]) : _c('el-button', {
                staticStyle: {
                  "width": "90px"
                },
                attrs: {
                  "size": "mini",
                  "type": "info",
                  "disabled": ""
                }
              }, [_vm._v("确认下线")])]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 678279218)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "show-overflow-tooltip": "",
      "label": "发行游戏",
      "align": "center",
      "min-width": "160px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "show-overflow-tooltip": "",
      "label": "对应公司",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "show-overflow-tooltip": "",
      "label": "对应渠道",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "show-overflow-tooltip": "",
      "label": "采集来源",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "atv",
      "label": "单价",
      "align": "center",
      "min-width": "70px",
      "formatter": _vm.fixed2Formatter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.atv))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visit_uv_new",
      "label": "买量新增",
      "min-width": "100px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.visit_uv_new - 0) - (b.visit_uv_new - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "买量成本",
      "align": "center",
      "min-width": "100px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost - 0) - (b.cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "_visit_uv_new",
      "label": "实际买量新增",
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv_new - 0) - (b._visit_uv_new - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130px",
      "prop": "_visit_uv",
      "label": "实际活跃用户",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._visit_uv - 0) - (b._visit_uv - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "_cost",
      "label": "实际买量成本",
      "formatter": _vm.fixed2Formatter,
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a._cost - 0) - (b._cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row._cost))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost_per",
      "label": "实际买量单价",
      "min-width": "130px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.cost_per - 0) - (b.cost_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      ￥"), _c('span', [_vm._v(_vm._s(scope.row.cost_per))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "下线时间",
      "align": "center",
      "min-width": "140px",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.update_time != null && (scope.row.status == 0 || scope.row.status == 2)) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "290"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '更多数据',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  sdate: _vm.pdata.sdate,
                  edate: _vm.pdata.edate,
                  getWhich: '买量详情'
                }
              })
            }
          }
        }, [_vm._v("回本详情")]), _vm._v(" "), ((_vm.groupid == 4 || _vm.groupid == 0 || _vm.groupid == 1) && (_vm.dateVal[0] === _vm.dateVal[1])) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editProduct(scope.row, '')
            }
          }
        }, [_vm._v("编辑")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑实际买量",
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseEditProduct
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际活跃用户"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_input", $$v)
      },
      expression: "chooseEditProduct.visit_uv_input"
    }
  })], 1)], 1), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际买量新增"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "disabled": _vm.chooseEditProduct._visit_uv_new_o != 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    on: {
      "change": _vm.visitUvNewKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_new_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_new_input", $$v)
      },
      expression: "chooseEditProduct.visit_uv_new_input"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际扣量新增"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "step": 1,
      "precision": 0,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.visit_uv_new_o),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "visit_uv_new_o", $$v)
      },
      expression: "chooseEditProduct.visit_uv_new_o"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 5) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际买量成本"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "disabled": _vm.chooseEditProduct.type != 3,
      "precision": 2,
      "min": 0,
      "label": "",
      "controls": false
    },
    model: {
      value: (_vm.chooseEditProduct.cost_input),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "cost_input", $$v)
      },
      expression: "chooseEditProduct.cost_input"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.chooseEditProduct.type != 3) ? _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "买量单价"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "small",
      "precision": 2,
      "min": 0,
      "label": "",
      "controls": false
    },
    on: {
      "change": _vm.atvKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.atv),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "atv", $$v)
      },
      expression: "chooseEditProduct.atv"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "采集来源"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择计价方式"
    },
    on: {
      "change": _vm.typeKeyup
    },
    model: {
      value: (_vm.chooseEditProduct.type),
      callback: function($$v) {
        _vm.$set(_vm.chooseEditProduct, "type", $$v)
      },
      expression: "chooseEditProduct.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editChooseProduct($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d04310"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/income/costDailyDetail.vue
// module id = 1123
// module chunks = 2